export default __webpack_public_path__ + "static/media/eye_icon.100c8cca.svg";